import { Component, OnInit, Renderer2, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthService } from '../auth/auth.service';
import { UserService } from '../user/user.service';
import { Router } from '@angular/router';
import { SpinnerService } from '../spinner/spinner.service';
import { InfoService } from '../info/info.service';
import { TranslateService } from '@ngx-translate/core';
import { AbstractComponent } from '@app/shared/component/AbstractComponent';
import { LoginResponse } from '../auth/loginResponse.model';
import { User } from '../user/model/User.model';
import { environment } from '@env/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent extends AbstractComponent implements OnInit, OnDestroy {

  @ViewChild('loginButton') loginButton: ElementRef;

  // formulario reactivo para el login
  loginForm: any;
  // si se ha submitido el formulario o no
  isSubmitted = false;
  dw = false;

  constructor(
    private renderer: Renderer2,
    public authService: AuthService,
    private userService: UserService,
    private router: Router,
    private spinnerService: SpinnerService,
    private infoService: InfoService,
    public translateService: TranslateService
  ) {
    super(authService, translateService);
  }

  ngOnInit(): void {

    // podemos el estilo específico para el login
    this.renderer.addClass(document.body, 'bg-gradient-primary');
    this.renderer.addClass(document.body, 'body-image');

    // inicializamos el formulario
    this.loginForm = new FormGroup({
      userName: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required]),
      keepMeLogged: new FormControl(false)
    });
    this.loginForm.patchValue({keepMeLogged: false});

    if (environment.envName === 'dw') {
      this.dw = true;
    }

  }

  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'bg-gradient-primary');
    this.renderer.removeClass(document.body, 'body-image');
  }

  login(): void {

    this.startSpinnerElement(this.loginButton);

    this.authService.removeToken();

    this.isSubmitted = true;
    if (this.loginForm.invalid) {
      return;
    }
    const userName = this.loginForm.controls.userName.value;
    const password = this.loginForm.controls.password.value;

    this.authService.login(userName, password, false).subscribe({
      next: (loginReponse: LoginResponse) => {
        this.authService.setToken(loginReponse.accessToken);
        // TODO cambiar el external false por lo correcto
        this.userService.getMe().subscribe({
          next: (userResponse: User) => {

            // si estamos en dw cambiamos todos los permisos por solo de lectura
            if (environment.envName == 'dw') {
              userResponse.role.permissions.forEach(permission => {
                permission.level = 'R'
              })
            }

            this.authService.setUser(userResponse );
            this.stopSpinnerElement(this.loginButton);
            void this.router.navigate(['']);
          },
          error: (error) => {
            if (!this.isConnectionError(error)) {
              this.errorCode = 'common.auth.login.unauthorized';
            }
            console.log('Authenticated Error');
            this.stopSpinnerElement(this.loginButton);
          }
        });
      },
      error: (error) => {
        if (!this.isConnectionError(error)) {
          this.errorCode = 'common.auth.login.unauthorized';
        }
        console.log('Authenticated Error');
        this.stopSpinnerElement(this.loginButton);
      }
    });
  }

}
